import React from "react";

import "./styles.scss";

export interface OverflowBadgeProps {
  count: number;
  tooltip: string;
  className?: string;
}

export const OverflowBadge: React.FunctionComponent<OverflowBadgeProps> = ({
  count,
  tooltip,
  className,
}) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      className={["overflow-badge", className].filter(Boolean).join(" ")}
      data-tooltip={tooltip}
    >
      +{count}
    </span>
  );
};

export default OverflowBadge;
